import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../axios/axiosInstance";
import { setResultModalData, showModal } from "../modal/modalSlice";

const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

const initialState = {
    
    errorMessage: "",

    mernisDataEArsiv:null,

    gibAccountInfo: {
      gibTaxName: JSON.parse(storage.getItem("gibTaxName")) || "",
      gibTaxOffice: JSON.parse(storage.getItem("gibTaxOffice")) || "", 
      gibVknTckn: JSON.parse(storage.getItem("gibVknTckn")) || "",
      gibToken: JSON.parse(storage.getItem("gibToken")) || "",
      gibCallId: JSON.parse(storage.getItem("gibCallId")) || "",
      gibCallIdCount: JSON.parse(storage.getItem("gibCallIdCount")) || ""
    },

    selectRegisteredUserEArsiv: null,

    selectedGibInvoice: null,
    gibConfirmationSmsMessage: "",

    registeredCustomerList:[],

    tevkifatCodes: [],

    //! loading & errors
    isLoadingSaveFatura: false,
    isErrorSaveFatura: false,

    isLoadingGibLogin: false,
    isErrorGibLogin: false,

    isLoadingGibLogout:false,
    isErrorGibLogout:false,

    isLoadingCreateInvoice:false,
    isErrorCreateInvoice:false,

    isLoadingGetGibKestigimFaturalar: false,
    gibKestigimFaturaList: [],
    
    isLoadingViewInvoice: false,
    isErrorViewInvoice: false,

    viewEArsivInvoiceData: null,
    isLoadingGetInvoice:false,
    isErrorGetInvoice:false,

    isLoadingSendSmsInvoice:false, 
    isErrorSendSmsInvoice:false, 

    isLoadingLocationPrice: false,
    isErrorLocationPrice: false,

    isLoadingAddCustomer:false,
    isErrorAddCustomer:false,

    isLoadingDeleteCustomer:false,
    isErrorDeleteCustomer:false,

}
//! e-arşiv fatura oluşturma
export const createEArsivInvoice = createAsyncThunk("eArsiv/createEArsivInvoice", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/CreateEArsivInvoice`, body)
        //! e-arşive entegre edilmiş apide her istekte callIdCount arttırılır
        let gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"));
            gibCallIdCount += 1;
            storage.setItem("gibCallIdCount", JSON.stringify(gibCallIdCount));

        return data.data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})

//! e-arşiv fatura listeleme
export const getGibKestigimFaturalar = createAsyncThunk("eArsiv/getGibKestigimFaturalar", async(body, thunkApi) => {
    try{

        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/GetEArsivInvoicesBetween`, body)

        return data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})

//! e-arşiv login
export const gibLoginPortal = createAsyncThunk("eArsiv/gibLoginPortal", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/LoginToPortal`, body)

        if(data?.token){
            storage.setItem("gibCallId", JSON.stringify(data?.callId))
            storage.setItem("gibCallIdCount", JSON.stringify(data?.callIdCount))
            storage.setItem("gibTaxName", JSON.stringify(data?.name))
            storage.setItem("gibTaxOffice", JSON.stringify(data?.taxOfficeName))
            storage.setItem("gibToken", JSON.stringify(data?.token))
            storage.setItem("gibVknTckn", JSON.stringify(data?.vknTckn))
            storage.setItem("gibUserId", JSON.stringify(data?.userId))
            thunkApi.dispatch(showModal(null))

            let gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"));
            gibCallIdCount += 1;
            storage.setItem("gibCallIdCount", JSON.stringify(gibCallIdCount));

            thunkApi.dispatch(setGibAccountInfo({
                gibTaxName: data?.name,
                gibTaxOffice: data?.taxOfficeName, 
                gibVknTckn: data?.vknTckn,
                gibToken: data?.token,
                gibCallId: data?.callId,
                gibCallIdCount: data?.callIdCount
            }))
        }
        return data.data
      }catch(error){
        thunkApi.dispatch(setErrorMessage(error.response.data.ErrorDto.Errors[0]))
        return thunkApi.rejectWithValue(error)
      }
})


//! e-arşiv logout
export const gibLogoutPortal = createAsyncThunk("eArsiv/gibLogoutPortal", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/Logout`, body)

        storage.removeItem("gibCallId")
        storage.removeItem("gibCallIdCount")
        storage.removeItem("gibTaxName")
        storage.removeItem("gibTaxOffice")
        storage.removeItem("gibToken")
        storage.removeItem("gibVknTckn")
        storage.removeItem("gibUserId")

        thunkApi.dispatch(setGibAccountInfo({
            gibTaxName: "",
            gibTaxOffice: "", 
            gibVknTckn: "",
            gibToken: "",
            gibCallId: "",
            gibCallIdCount: ""
        }))
        return data.data
    }catch(error){
        storage.removeItem("gibCallId")
        storage.removeItem("gibCallIdCount")
        storage.removeItem("gibTaxName")
        storage.removeItem("gibTaxOffice")
        storage.removeItem("gibToken")
        storage.removeItem("gibVknTckn")
        storage.removeItem("gibUserId")

        thunkApi.dispatch(setGibAccountInfo({
            gibTaxName: "",
            gibTaxOffice: "", 
            gibVknTckn: "",
            gibToken: "",
            gibCallId: "",
            gibCallIdCount: ""
        }))
        return thunkApi.rejectWithValue(error)
    }
})

//! 
export const getEArsivInvoicesBetween = createAsyncThunk("eArsiv/getEArsivInvoicesBetween", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/GetEArsivInvoicesBetween`, body)

        let gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"));
            gibCallIdCount += 1;
            storage.setItem("gibCallIdCount", JSON.stringify(gibCallIdCount));

        return data.data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv fatura silme

export const deleteEArsivInvoice = createAsyncThunk("eArsiv/deleteEArsivInvoice", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/DeleteEArsivInvoice`, body)

        let gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"));
            gibCallIdCount += 1;
            storage.setItem("gibCallIdCount", JSON.stringify(gibCallIdCount));

        if(data?.message){
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
            setResultModalData({
                msg: data?.message,
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
            })
            );
        }
    

        return data.data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv sms gönderme
export const sendConfirmationSms = createAsyncThunk("eArsiv/sendConfirmationSms", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/SendConfirmationSms`, body)

        if (data?.message) {
            thunkApi.dispatch(showModal("gibKestigimFaturaSmsVerification"));
        }


        let gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"));
            gibCallIdCount += 1;
            storage.setItem("gibCallIdCount", JSON.stringify(gibCallIdCount));

        return data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv sms onaylama
export const signInvoiceWithSmsCode = createAsyncThunk("eArsiv/signInvoiceWithSmsCode", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/SignInvoiceWithSmsCode`, body)

        if(data?.message){
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
            setResultModalData({
                msg: data?.message,
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
            })
            );
        }

        let gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"));
            gibCallIdCount += 1;
            storage.setItem("gibCallIdCount", JSON.stringify(gibCallIdCount));
        
        return data.data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv fatura görüntüleme
export const viewEArsivInvoice = createAsyncThunk("eArsiv/viewEArsivInvoice", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/ViewEArsivInvoice`, body)

        let gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"));
            gibCallIdCount += 1;
            storage.setItem("gibCallIdCount", JSON.stringify(gibCallIdCount));

        if(data?.message){
            thunkApi.dispatch(showModal("gibFaturaDetailHtml"))
        }
        return data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv mernis bilgileri
export const getMernisDataEArsiv = createAsyncThunk("eArsiv/getMernisDataEArsiv", async(query, thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/E_Arsiv_Fatura/GetMernisData?VknTckn=${query}`)


        if(data?.message){
            thunkApi.dispatch(showModal("gibFaturaDetailHtml"))
        }
        return data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv fatura iptal
export const cancelSignedInvoice = createAsyncThunk("eArsiv/cancelSignedInvoice", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.put(`/E_Arsiv_Fatura/CancelSignedInvoiceRequest`, body)

        if(data?.message){
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
            setResultModalData({
                msg: data?.message,
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
            })
            );
        }

        let gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"));
            gibCallIdCount += 1;
            storage.setItem("gibCallIdCount", JSON.stringify(gibCallIdCount));

        return data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})

export const createEArsivLocationPrice = createAsyncThunk("eArsiv/createEArsivLocationPrice", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/CreateEArsivLocationNPrice`, body)


        if(data?.message){
            thunkApi.dispatch(showModal("gibFaturaDetailHtml"))
        }
        return data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv müşteri listesi
export const getSavedEArsivCustomer = createAsyncThunk("eArsiv/getSavedEArsivCustomer", async(_, thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/E_Arsiv_Fatura/GetAllSavedEArsivCustomer`)

        return data.data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv müşteri ekleme
export const createSavedEArsivCustomer = createAsyncThunk("eArsiv/createSavedEArsivCustomer", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/createSavedEArsivCustomer`, body)


        if(data){
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
                setResultModalData({
                    msg: "Başarılı bir şekilde eklendi.",
                    resultType: "success",
                    btnText1: "Listeyi Görüntüle",
                })
            );
        }
        return data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv müşteri silme
export const deleteSavedEArsivCustomer = createAsyncThunk("eArsiv/deleteSavedEArsivCustomer", async(id, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/E_Arsiv_Fatura/DeleteSavedEArsivCustomer`, id)


        if(data?.statusCode === 200){
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
            setResultModalData({
                msg: "Başarılı bir şekilde silindi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
            })
            );
        }
        return data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})
//! e-arşiv tevkifat kodları
export const getTevkifatData = createAsyncThunk("eArsiv/getTevkifatData", async(_, thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/E_Arsiv_Fatura/GetAllTevkifatCodes`)


        return data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})


const eArsivSlice = createSlice({
    name: "eArsiv",
    initialState,
    reducers:{
        setErrorMessage: (state, action) => {
            state.errorMessage = action.payload
        },

        setGibAccountInfo: (state, action) => {
            state.gibAccountInfo = action.payload
        },

        setSelectedGibInvoice: (state, action) => {
            state.selectedGibInvoice = action.payload
        },

        setSelectRegisteredUserEArsiv: (state, action) => {
            state.selectRegisteredUserEArsiv = action.payload
        }
    },
    extraReducers: (builder) => {
        builder

        .addCase(createEArsivInvoice.pending, (state) => {
            state.isLoadingCreateInvoice = true;
        })
        .addCase(createEArsivInvoice.fulfilled, (state, action) => {
            state.isLoadingCreateInvoice = false;
        })
        .addCase(createEArsivInvoice.rejected, (state) => {
            state.isLoadingCreateInvoice = true
            state.isErrorCreateInvoice = false;
        })

        .addCase(gibLoginPortal.pending, (state) => {
            state.isLoadingGibLogin = true;
        })
        .addCase(gibLoginPortal.fulfilled, (state, action) => {
            state.isLoadingGibLogin = false;
        })
        .addCase(gibLoginPortal.rejected, (state) => {
            state.isLoadingGibLogin = true
            state.isErrorGibLogin = false;
        })

        .addCase(gibLogoutPortal.pending, (state) => {
            state.isLoadingGibLogout = true;
        })
        .addCase(gibLogoutPortal.fulfilled, (state, action) => {
            state.isLoadingGibLogout = false;
        })
        .addCase(gibLogoutPortal.rejected, (state) => {
            state.isLoadingGibLogout = true
            state.isLoadingGibLogout = false;
        })


        .addCase(getGibKestigimFaturalar.pending, (state) => {
            state.isLoadingGetGibKestigimFaturalar = true;
        })
        .addCase(getGibKestigimFaturalar.fulfilled, (state, action) => {
            state.isLoadingGetGibKestigimFaturalar = false;
            state.gibKestigimFaturaList = action.payload
        })
        .addCase(getGibKestigimFaturalar.rejected, (state) => {
            state.isLoadingGetGibKestigimFaturalar = true
        })



        .addCase(deleteEArsivInvoice.pending, (state) => {
            state.isLoadingCreateInvoice = true;
        })
        .addCase(deleteEArsivInvoice.fulfilled, (state, action) => {
            state.isLoadingCreateInvoice = false;
        })
        .addCase(deleteEArsivInvoice.rejected, (state) => {
            state.isLoadingCreateInvoice = true
            state.isErrorCreateInvoice = false;
        })
        
        .addCase(sendConfirmationSms.pending, (state) => {
            state.isLoadingSendSmsInvoice = true;
        })
        .addCase(sendConfirmationSms.fulfilled, (state, action) => {
            state.isLoadingSendSmsInvoice = false;
            state.gibConfirmationSmsMessage = action.payload.message
        })
        .addCase(sendConfirmationSms.rejected, (state) => {
            state.isLoadingSendSmsInvoice = true
            state.isErrorSendSmsInvoice = false;
        })

        .addCase(signInvoiceWithSmsCode.pending, (state) => {
            state.isLoadingSendSmsInvoice = true;
        })
        .addCase(signInvoiceWithSmsCode.fulfilled, (state, action) => {
            state.isLoadingSendSmsInvoice = false;
        })
        .addCase(signInvoiceWithSmsCode.rejected, (state) => {
            state.isLoadingSendSmsInvoice = true
            state.isErrorSendSmsInvoice = false;
        })

        .addCase(viewEArsivInvoice.pending, (state) => {
            state.isLoadingViewInvoice = true;
        })
        .addCase(viewEArsivInvoice.fulfilled, (state, action) => {
            state.isLoadingViewInvoice = false;
            state.viewEArsivInvoiceData = action.payload.message
        })
        .addCase(viewEArsivInvoice.rejected, (state) => {
            state.isLoadingViewInvoice = true
            state.isErrorViewInvoice = false;
        })

        .addCase(getMernisDataEArsiv.pending, (state) => {
            state.isLoadingViewInvoice = true;
        })
        .addCase(getMernisDataEArsiv.fulfilled, (state, action) => {
            state.isLoadingViewInvoice = false;
            state.mernisDataEArsiv = action.payload
        })
        .addCase(getMernisDataEArsiv.rejected, (state) => {
            state.isLoadingViewInvoice = true
            state.isErrorViewInvoice = false;
        })

        
        .addCase(createEArsivLocationPrice.pending, (state) => {
            state.isLoadingLocationPrice = true;
        })
        .addCase(createEArsivLocationPrice.fulfilled, (state, action) => {
            state.isLoadingLocationPrice = false;
            state.mernisDataEArsiv = action.payload
        })
        .addCase(createEArsivLocationPrice.rejected, (state) => {
            state.isLoadingLocationPrice = true
            state.isErrorLocationPrice = false;
        })

        
        .addCase(cancelSignedInvoice.pending, (state) => {
            state.isLoadingCreateInvoice = true;
        })
        .addCase(cancelSignedInvoice.fulfilled, (state, action) => {
            state.isLoadingCreateInvoice = false;
        })
        .addCase(cancelSignedInvoice.rejected, (state) => {
            state.isLoadingCreateInvoice = true
            state.isErrorCreateInvoice = false;
        })

        .addCase(createSavedEArsivCustomer.pending, (state) => {
            state.isLoadingAddCustomer = true;
        })
        .addCase(createSavedEArsivCustomer.fulfilled, (state, action) => {
            state.isLoadingAddCustomer = false;
            state.registeredCustomerList = [...state.registeredCustomerList , action.payload]
            state.mernisDataEArsiv = null
        })
        .addCase(createSavedEArsivCustomer.rejected, (state) => {
            state.isLoadingAddCustomer = true
            state.isErrorAddCustomer = false;
        })

        
        .addCase(getSavedEArsivCustomer.pending, (state) => {
            state.isLoadingViewInvoice = true;
        })
        .addCase(getSavedEArsivCustomer.fulfilled, (state, action) => {
            state.isLoadingViewInvoice = false;
            state.registeredCustomerList = action.payload.$values
        })
        .addCase(getSavedEArsivCustomer.rejected, (state) => {
            state.isLoadingViewInvoice = true
            state.isErrorViewInvoice = false;
        })

        .addCase(deleteSavedEArsivCustomer.pending, (state) => {
            state.isLoadingDeleteCustomer = true;
        })
        .addCase(deleteSavedEArsivCustomer.fulfilled, (state, action) => {
            state.isLoadingDeleteCustomer = false;
            state.registeredCustomerList = state.registeredCustomerList.filter((item) => {
                return item.id !== action.payload.id
            })
        })
        .addCase(deleteSavedEArsivCustomer.rejected, (state) => {
            state.isLoadingDeleteCustomer = true
            state.isErrorDeleteCustomer = false;
        })

        .addCase(getTevkifatData.pending, (state) => {
            state.isLoadingGetInvoice = true;
        })
        .addCase(getTevkifatData.fulfilled, (state, action) => {
            state.isLoadingGetInvoice = false;
            state.tevkifatCodes = action.payload.$values
        })
        .addCase(getTevkifatData.rejected, (state) => {
            state.isLoadingGetInvoice = true
            state.isErrorDeleteCustomer = false;
        })
    }
})

export const {setErrorMessage, setGibAccountInfo, setSelectedGibInvoice, setSelectRegisteredUserEArsiv} = eArsivSlice.actions
export default eArsivSlice.reducer